import type { I18nDict } from '../types.ts'

export const fi: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Asetukset',
  section_language: 'Kieli',
  section_identity: 'Paikallinen identiteetti',
  section_updates: 'Sovelluspäivitys',
  section_notifications: 'Ilmoitukset',
  section_theme: 'Visuaalinen teema',
  section_backup: 'Keskustelun varmuuskopio',
  section_privacy_network: 'Verkon yksityisyys',
  section_media: 'Multimedia',
  section_security: 'Turvallisuus ja salasana',
  section_exit: 'Sulje ja tuhoa tiedot',
  toggle_external_links: 'Vastaanota ja näytä ulkoiset linkit',
  hint_external_links: 'Jos POIS: ei linkkien esikatselua keskustelussa eikä ulkoisia URL-osoitteita voi avata (IP-seurannan suojaus).',
  toggle_auto_media: 'Automaattinen median ja asiakirjojen lataus',
  hint_auto_media: 'Jos POIS: kuvia, videoita ja tiedostoja ei ladata taustalla — napauta manuaalisesti keskustelussa.',
  toggle_require_unlock: 'Salasana sovelluksen avauksessa',
  hint_require_unlock: 'Kun PÄÄLLÄ, pääsalasana vaaditaan aina, kun avaat ZIONin.',
  toggle_wipe_exit: 'Poista tiedot suljettaessa',
  hint_wipe_exit: 'Kun PÄÄLLÄ, sovelluksen sulkeminen tyhjentää väliaikaisen RAM-välimuistin ja istuntotiedot.',
  btn_exit: 'Poistu',
  btn_delete_all: 'POISTA KAIKKI TIEDOT',
  btn_lock: 'Lukitse sovellus',
  btn_back: 'Takaisin',
  warn_disable_password_title: '⚠️ VAROITUS',
  warn_disable_password_body: 'Avaussalasanan poistaminen käytöstä tarkoittaa, että kuka tahansa laitteesi käyttäjä voi lukea salatut viestisi. Haluatko varmasti jatkaa?',
  warn_delete_all_1: 'Haluatko todella tuhota koko tietokannan? Tätä toimintoa ei voi peruuttaa.',
  warn_delete_all_2: 'Lopullinen vahvistus: kaikki keskustelut, yksityiset avaimet ja asetukset poistetaan pysyvästi.',
  link_blocked: 'Ulkoinen linkki estetty (yksityisyysasetukset).',
  lang_welcome_title: 'Tervetuloa ZIONiin',
  lang_welcome_sub: 'Valitse kieli',
  lang_continue: 'Jatka',
  settings_language_label: 'Sovelluksen kieli',
  auth_unlock_title: 'Avaa',
  auth_or_password: '— tai avaa salasanalla —',
  auth_password_master: 'Pääsalasana',
  auth_unlock_btn: 'Avaa',
  auth_verifying: 'Vahvistetaan…',
  auth_wrong_password: 'Väärä salasana',
  auth_unlocked: 'Avattu ✓',
  auth_access_title: 'Liity ZIONiin',
  auth_beta_spots: 'Ilmainen beta · paikkoja jäljellä:',
  auth_beta_full: 'Beta täynnä ({max} käyttäjää). Yritä myöhemmin uudelleen.',
  auth_beta_free: 'Ilmainen beta · lisenssiä ei vaadita',
  auth_or_create: '— tai luo uusi identiteetti —',
  auth_password_min: 'Salasana (väh. 8 merkkiä)',
  auth_password_confirm: 'Vahvista salasana',
  auth_privacy_check: 'Olen lukenut',
  auth_privacy_link: 'Tietosuojakäytännön',
  auth_terms_check: 'Hyväksyn',
  auth_terms_link: 'Käyttöehdot',
  auth_password_local_hint: 'Salasana ei koskaan poistu tästä laitteesta. Ei palvelintiliä.',
  auth_create_identity: 'Luo identiteetti',
  auth_accept_legal_err: 'Hyväksy tietosuoja ja ehdot jatkaaksesi',
  auth_generating_keys: 'Luodaan avaimia ja istuntoa…',
  auth_generating_identity: 'Luodaan anonyymi identiteetti…',
  auth_generating_detail: 'ECDH-avaimet · lempinimi · socket-istunto · ZN- koodi',
  auth_you_are: 'Olet',
  auth_daily_suffix_hint: 'Päivittäinen liite muuttuu joka UTC-päivä. Paritaksesi, käytä ZN- koodia Etusivulla.',
  auth_enter: 'Siirry ZIONiin',
  auth_starting: 'Käynnistetään…',
  auth_restore_title: 'Palauta varmuuskopio',
  auth_restore_hint: 'Onko sinulla jo salattu varmuuskopio? Palauta identiteetti, yhteystiedot ja keskustelut (esim. välimuistin tyhjentämisen jälkeen).',
  auth_restore_file: 'Varmuuskopiotiedosto (.enc / .enc.json)',
  auth_restore_pass: 'Varmuuskopion salalause',
  auth_restore_pass_ph: 'Viennissä käytetty salalause',
  auth_restore_btn: 'Palauta varmuuskopio',
  auth_restore_pick_file: 'Valitse varmuuskopiotiedosto (.enc tai .enc.json).',
  auth_restore_need_pass: 'Syötä salalause.',
  auth_restoring: 'Palautetaan…',
  auth_file_prefix: 'Tiedosto:',
  common_accept: 'Hyväksy',
  common_reject: 'Hylkää',
  common_cancel: 'Peruuta',
  common_accepting: 'Hyväksytään…',
  common_error: 'Virhe',
  common_loading: 'Ladataan…',
  common_send: 'Lähetä',
  common_copied: 'Kopioitu ✓',
  common_copy_failed: 'Kopiointi epäonnistui',
  common_ok: 'OK',
  common_today: 'Tänään',
  common_yesterday: 'Eilen',
  common_sending: 'Lähetetään…',
  home_zn_midnight_hint: 'Muuttuu UTC keskiyöllä (aikaa {h}h {m}m)',
  home_temp_empty: 'Ei aikarajoitettuja keskusteluja. Napauta ⏱ yhteystiedossa aloittaaksesi.',
  home_unread_aria: '{count} viestiä',
  home_temp_waiting: 'Odotetaan hyväksyntää…',
  home_temp_expires: 'Aikarajoitettu keskustelu · vanhenee {remaining} kuluttua',
  home_temp_cancel: 'Peruuta',
  home_temp_fallback_label: 'aikarajoitettu keskustelu',
  home_temp_invite_title: '⏱ Kutsu aikarajoitettuun keskusteluun',
  home_temp_invite_body: '{nick} haluaa tilapäisen keskustelun ({duration}).',
  home_temp_invite_hint: 'Hyväksy aloittaaksesi viestien vaihdon, jotka katoavat vanhentuessa.',
  home_temp_accept: 'Hyväksy',
  home_temp_reject: 'Hylkää',
  home_temp_accepting: 'Hyväksytään…',
  home_contacts_empty: 'Ei yhteystietoja. Jaa ZN- koodisi tai QR paritaksesi.',
  home_temp_chat_aria: 'Aikarajoitettu keskustelu',
  home_btn_pair_title: 'Parita',
  home_btn_settings_title: 'Asetukset',
  home_zn_title: 'Tämän päivän ZN- koodi',
  home_btn_copy_zn: 'Kopioi ZN-',
  home_btn_open_pair: 'Paritus-QR',
  home_section_temp: 'Aikarajoitetut keskustelut',
  home_section_chat: 'Keskustelut',
  home_loading: 'Ladataan…',
  home_pair_zn_title: 'Parita ZN- koodilla',
  home_btn_zn_pair: 'Lähetä pyyntö',
  home_copied: 'Kopioitu ✓',
  home_copy_failed: 'Kopiointi epäonnistui',
  home_pair_request_title: 'Yhteystietopyyntö',
  home_pair_request_body: '{name} haluaa keskustella.',
  home_pair_reject: 'Hylkää',
  home_pair_accept: 'Hyväksy',
  home_pair_accepting: 'Hyväksytään…',
  home_pair_accept_failed: 'Hyväksyminen epäonnistui',
  home_zn_digits_err: 'Syötä 5 numeroa ZN- jälkeen.',
  home_sending: 'Lähetetään…',
  chat_rename: 'Nimeä uudelleen',
  chat_rename_matrix: '[NIMEÄ UUDELLEEN]',
  chat_rename_title: 'Nimeä yhteystieto uudelleen',
  chat_menu_title: 'Keskusteluasetukset',
  chat_loading: 'Ladataan viestejä…',
  chat_reply_to: 'Vastaa',
  chat_cancel_title: 'Peruuta',
  chat_voice_lock_hint: 'Pyyhkäise ylös lukitaksesi tallennuksen',
  chat_voice_locked: 'Tallennus lukittu — napauta Valmis',
  chat_voice_stop: 'VALMIS',
  chat_voice_stop_title: 'Valmis',
  chat_voice_preview_label: 'Ääniesikatselu — kuuntele ennen lähettämistä',
  chat_voice_send: 'LÄHETÄ',
  chat_voice_send_title: 'Lähetä',
  chat_timer_label: 'Ajastin',
  chat_timer_title: 'Viestiajastin',
  chat_timer_off: 'POIS',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Kuva',
  chat_photo_title: 'Kuva',
  chat_voice_hold: 'Pidä painettuna tallentaaksesi',
  chat_voice_hold_title: 'Pidä painettuna tallentaaksesi',
  chat_doc: 'Dok',
  chat_doc_title: 'Asiakirja',
  chat_attach_title: 'Liitteet',
  chat_input_placeholder: 'E2E-salattu viesti…',
  chat_send: 'Lähetä',
  chat_rename_modal_title: 'Nimeä yhteystieto uudelleen',
  chat_rename_nickname: 'Lempinimi: @{nick}',
  chat_rename_placeholder: 'Mukautettu nimi',
  chat_rename_cancel: 'Peruuta',
  chat_rename_save: 'Tallenna',
  chat_action_reply: '↩ Vastaa',
  chat_action_copy: '⎘ Kopioi',
  chat_action_delete_me: '🗑 Poista minulta',
  chat_action_delete_all: '🗑 Poista kaikilta',
  chat_action_cancel: 'Peruuta',
  chat_menu_clear_me: '🗑 Tyhjennä keskustelu (vain minulta)',
  chat_menu_clear_all: '🗑 Poista keskustelu kaikilta',
  chat_menu_cancel: 'Peruuta',
  chat_doc_send_title: 'Lähetä asiakirja',
  chat_doc_default_name: 'asiakirja',
  chat_doc_send_hint: 'Tiedosto pakataan, E2E-salataan ja lähetetään. Enint. 5 MB.',
  chat_doc_cancel: 'Peruuta',
  chat_doc_send_encrypted: 'Lähetä salattuna',
  chat_doc_too_large: '⚠️ TIEDOSTO LIIAN SUURI: Asiakirjojen enimmäisturvaraja on 5 MB.',
  chat_doc_unsupported: 'Asiakirjatyyppiä ei tueta.',
  chat_copy_failed: 'Kopiointi epäonnistui',
  chat_confirm_delete_me: 'Poistetaanko tämä viesti vain sinulta?',
  chat_confirm_delete_all: 'Poistetaanko tämä viesti kaikilta?',
  chat_confirm_clear_all: 'Poistetaanko koko keskustelu kaikilta? Tätä toimintoa ei voi peruuttaa.',
  chat_confirm_clear_me: 'Tyhjennetäänkö keskustelu vain sinulta?',
  chat_jump_new: '↓ Uudet viestit',
  chat_empty: 'Ei viestejä. Kirjoita jotain aloittaaksesi.',
  chat_voice_err_short: 'Ääniviesti liian lyhyt (vähintään 1 sekunti).',
  chat_voice_err_long: 'Ääniviesti liian pitkä (enintään 2 minuuttia).',
  chat_voice_err_large: 'Ääniviesti liian suuri (enint. 3 MB).',
  chat_voice_err_start: 'Äänitallennusta ei voitu aloittaa.',
  chat_destroyed: '✉ Viesti luettu ja tuhottu',
  chat_destroyed_title: 'Viesti luettu ja tuhottu',
  chat_hold_options: 'Pidä painettuna asetuksia varten',
  chat_reply_fallback: 'Viesti',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'ZN- koodi muuttuu UTC keskiyöllä (aikaa {h}h {m}m).',
  pair_copied: 'Kopioitu ✓',
  pair_copy_failed: 'Kopiointi epäonnistui',
  pair_title: 'Paritus',
  pair_zn_title: 'ZN- koodisi tänään',
  pair_btn_copy_zn: 'Kopioi ZN- koodi',
  pair_tab_mine: 'Oma QR',
  pair_tab_scan: 'Skannaa / ZN-',
  pair_qr_aria: 'Paritus-QR',
  pair_expires_in: 'Vanhenee',
  pair_btn_copy_payload: 'Kopioi payload',
  pair_btn_regen_qr: 'Luo uusi QR',
  pair_qr_hint: 'Näytä tämä QR toiselle laitteelle. Voimassa 10 minuuttia — yhteensopiva Android-sovelluksen kanssa.',
  pair_expired: 'vanhentunut',
  pair_contact_zn_title: 'Yhteystiedon ZN- koodi',
  pair_zn_prefix_hint: 'Etuliite <strong>ZN-</strong> on jo asetettu — syötä vain 5 kirjainta/numeroa.',
  pair_btn_zn_request: 'Lähetä ZN- pyyntö',
  pair_paste_title: 'Tai liitä ZION1:: QR',
  pair_paste_hint: 'Liitä <code>ZION1::</code> payload tai lataa QR-koodin kuva.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Kuvasta / kamerasta',
  pair_btn_connect_qr: 'Yhdistä QR:llä',
  pair_zn_digits_err: 'Syötä 5 numeroa ZN- jälkeen.',
  pair_sending: 'Lähetetään pyyntöä…',
  pair_reading_qr: 'Luetaan QR…',
  pair_qr_not_found: 'QR-koodia ei löytynyt kuvasta.',
  pair_zn_read_ok: 'ZN- koodi luettu — vahvista Lähetä pyyntö -painikkeella.',
  pair_qr_read_ok: 'QR luettu — vahvista Yhdistä QR:llä -painikkeella.',
  pair_qr_read_err: 'Virhe QR:n lukemisessa.',
  settings_identity_hint: 'Salasana ja avaimet pysyvät tässä selaimessa. Ei palvelintiliä.',
  settings_btn_add_home: 'Opas: Lisää kotinäytölle',
  settings_devices_title: 'Linkitetyt laitteet',
  settings_devices_hint: 'Monilaitteinen Zero-Knowledge: avaimet siirtyvät E2E-salattuna. Palvelin on vain välittäjä.',
  settings_btn_link_device: 'Linkitä uusi laite',
  settings_btn_sync_pc: 'Synkronoi PC-historia',
  settings_no_devices: 'Ei linkitettyjä laitteita.',
  settings_device_self: 'tämä laite',
  settings_version_prefix: 'Versio:',
  settings_ios_push_hint: '<strong>iPhone:</strong> ilmoitukset = PWA kotinäytöltä + Banner/Ääni PÄÄLLÄ. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Pakota sovelluspäivitys',
  settings_updating: 'Päivitetään…',
  settings_push_mode_prefix: 'Tila:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> ilmoitukset toimivat vain, kun ZION avataan kotinäytön kuvakkeesta (Jaa → Lisää kotinäytölle). Tavallisessa Safarissa ne <em>eivät</em> ole saatavilla — edes iOS 17:ssä. Kotinäytölle asennuksen jälkeen palaa tänne ja napauta Ota ilmoitukset käyttöön.',
  settings_btn_enable_push: 'Ota push-ilmoitukset käyttöön',
  settings_btn_desktop_notify: 'Työpöytäilmoitukset (PC)',
  settings_btn_disable_push: 'Poista ilmoitukset käytöstä',
  settings_desktop_requesting: 'Pyydetään työpöytälupaa…',
  settings_desktop_ok: 'Työpöytäilmoitukset aktiiviset (ääni + ponnahdusikkuna uudessa viestissä).',
  settings_desktop_denied: 'Lupa evätty tai ei tuettu.',
  settings_push_no_session: 'Istunto ei ole valmis.',
  settings_push_requesting: 'Pyydetään lupaa…',
  settings_push_active: 'Ilmoitukset aktiiviset.',
  settings_push_disabled: 'Ilmoitukset pois käytöstä.',
  settings_theme_hint: 'Samat teemat kuin ZION Android -sovelluksessa.',
  settings_theme_recommended: 'Suositeltu',
  settings_backup_hint: 'JSON-tiedosto salattu salalauseella (yhteensopiva Android v2 -muodon kanssa). Tallenna PC:lle: yhteystiedot, keskustelut ja verkkoidentiteetti.',
  settings_backup_pass_label: 'Varmuuskopion salalause',
  settings_backup_pass_ph: 'Erillinen salalause (väh. 8 merkkiä)',
  settings_btn_export_backup: 'Vie varmuuskopio',
  settings_backup_file_label: 'Palauta tiedostosta',
  settings_backup_import_pass_label: 'Varmuuskopion salalause',
  settings_backup_import_pass_ph: 'Viennissä käytetty salalause',
  settings_btn_import_backup: 'Palauta varmuuskopio',
  settings_backup_file_prefix: 'Tiedosto: {name}',
  settings_backup_pass_min: 'Salalauseen on oltava vähintään 8 merkkiä.',
  settings_backup_creating: 'Luodaan varmuuskopiota…',
  settings_backup_pick_file: 'Valitse varmuuskopiotiedosto (.enc tai .enc.json).',
  settings_backup_need_pass: 'Syötä varmuuskopion salalause.',
  settings_backup_restoring: 'Palautetaan…',
  settings_backup_overwrite_confirm: 'Korvataanko paikalliset tiedot?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minuuttia',
  temp_duration_10m: '10 minuuttia',
  temp_duration_15m: '15 minuuttia',
  temp_duration_30m: '30 minuuttia',
  temp_duration_1h: '1 tunti',
  temp_duration_6h: '6 tuntia',
  temp_duration_24h: '24 tuntia',
  temp_duration_7d: '7 päivää',
  temp_remaining_expired: 'Vanhentunut',
  temp_remaining_days: '{days}pv {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Aikarajoitettu keskustelu · tilapäiset viestit',
  temp_empty: 'Ei tilapäisiä viestejä.',
  temp_empty_hint: 'Kirjoita tilapäinen viesti. Se katoaa, kun ajastin vanhenee.',
  temp_input_placeholder: 'Tilapäinen viesti…',
  temp_send: 'Lähetä',
  temp_waiting_accept: 'Odotetaan, että {name} hyväksyy aikarajoitetun keskustelun…',
  temp_waiting_placeholder: 'Odotetaan hyväksyntää…',
  temp_expires_in: 'Vanhenee {remaining} kuluttua',
  temp_duration_title: 'Aikarajoitettu keskustelu',
  temp_duration_with: 'Henkilön {name} kanssa',
  temp_duration_hint: 'Valitse kesto — keskustelu katoaa molemmilta laitteilta.',
  temp_sending_invite: 'Lähetetään kutsua…',
  voice_lock_hint: 'Pyyhkäise ylös lukitaksesi tallennuksen',
  voice_locked: 'Tallennus lukittu — napauta Valmis',
  add_home_title: 'Lisää kotinäytölle (iPhone / iPad)',
  add_home_guide_title: 'Safari-opas',
  add_home_step1: 'Avaa <strong>Safari</strong> tällä sivulla (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Napauta <strong>Jaa</strong> (neliö ylöspäin osoittavalla nuolella)',
  add_home_step3: 'Valitse <strong>Lisää kotinäytölle</strong>',
  add_home_step4: 'Avaa ZION <strong>kuvakkeesta</strong> — ei Safari-välilehdestä',
  add_home_hint: 'iOS/iPadOS 16.4+:ssa kotinäytön sovellus tukee Web Push -ilmoituksia ja keskustelun näppäimistöä. Asennuksen jälkeen siirry kohtaan <strong>Asetukset → Ota ilmoitukset käyttöön</strong>.',
  add_home_btn_continue: 'Selvä — jatka',
  add_home_btn_skip: 'Ohita toistaiseksi',
  search_title: 'Hae ZN- koodilla',
  search_label: 'Päivittäinen ZN- koodi',
  search_placeholder: 'ZN-123456',
  search_btn: 'Hae',
  search_hint: 'Syötä yhteystiedon ZN- koodi. Ei lempinimihakua — identiteetti on vain paikallinen.',
  search_format_err: 'Muoto: ZN-123456',
  search_resolving: 'Ratkaistaan koodia…',
  search_invalid_code: 'Virheellinen koodi — pyydä päivitettyä ZN- (avaa ZION uudelleen toisen henkilön laitteella)',
  search_session_found: 'istunto löytyi',
  search_tap_to_send: 'Napauta lähettääksesi pyynnön',
  search_socket_not_ready: 'Socket-istunto ei ole valmis',
  search_request_sent: 'Pyyntö lähetetty ✓',
  search_request_failed: 'Lähetys epäonnistui',
  license_title: 'Web- / iPhone-lisenssin aktivointi',
  license_heading: 'Lisenssi',
  license_heading_updated: 'Päivitetyt ehdot',
  license_hint: 'Syötä zionyx.ch:stä ostettu koodi <strong>ZION-XXXX-XXXX-XXXX</strong>. Se linkitetään tähän selaimeen (paikallinen avain).',
  license_code_label: 'Lisenssikoodi',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Aktivoi lisenssi',
  license_beta_hint: 'Web-beta: käytä erillistä iPhone-lisenssiä, jos saatavilla.',
  license_accept_legal_err: 'Hyväksy tietosuoja ja ehdot jatkaaksesi',
  license_need_code: 'Syötä lisenssikoodi',
  license_verifying: 'Vahvistetaan lisenssiä…',
  license_invalid_or_used: 'Virheellinen lisenssi tai jo käytetty toisella laitteella',
  license_active: 'Lisenssi aktiivinen ✓',
  license_err_not_found: 'Virheellinen lisenssikoodi',
  license_err_conflict: 'Lisenssi jo linkitetty toiseen laitteeseen',
  license_err_rate_limit: 'Liian monta yritystä — odota minuutti',
  license_err_generic: 'Lisenssivirhe',
  link_device_title: 'Linkitä uusi laite',
  link_device_hint: '<strong>PC:llä</strong> avaa Asetukset → Linkitä uusi laite: näet <strong>vihreän QR:n</strong>. Skannaa se alla (kamera tai kuva).',
  link_device_status_ready: '[VALMIS]',
  link_device_upload_label: 'Lataa QR-kuva',
  link_device_btn_camera: 'Avaa kamera / galleria',
  link_device_placeholder: 'QR-linkki tai payload…',
  link_device_btn_send_vault: 'Lähetä salattu holvi',
  link_device_err_invalid_qr: 'Virheellinen tai vanhentunut QR.',
  link_device_status_invalid: '[VIRHEELLINEN QR]',
  link_device_status_sync_complete: '[SYNKRONOINTI VALMIS]',
  link_device_status_transfer_failed: '[SIIRTO EPÄONNISTUI]',
  link_device_status_qr_detected: '[QR HAVAITTU — SIIRRETÄÄN...]',
  link_device_status_tap_camera: '[NAPAUTA VIHREÄÄ PAINIKETTA — IPHONE-KAMERA]',
  link_device_status_use_camera_below: '[KÄYTÄ KAMERAA / GALLERIAA ALLA]',
  link_device_status_point_camera: '[SUUNNAA KAMERA PC-QR:ÄÄ KOHTI...]',
  link_device_status_decoding: '[DEKODATAAN QR...]',
  link_device_status_qr_not_found: '[QR:ÄÄ EI LÖYTYNT]',
  link_device_status_decode_failed: '[DEKODAUS EPÄONNISTUI]',
  link_device_status_opened_from_qr: '[AVATTU QR:STÄ — KÄYNNISTETÄÄN...]',
  link_recv_title: 'Linkitä puhelimesta',
  link_recv_hint_compact:
    'Skannaa tämä <strong>vihreä QR</strong> puhelimella (Asetukset → Linkitä uusi laite). Holvi on päästä päähän -salattu.',
  link_recv_hint_auth:
    'Onko ZION jo puhelimessa? Skannaa tämä QR <strong>Kameralla</strong> — PC linkittyy ja kirjautuu automaattisesti.',
  link_recv_qr_alt: 'Laitelinkin QR',
  link_recv_copy_link: 'Kopioi linkki',
  link_recv_awaiting: '[ODOTETAAN PUHELIMEN SKANNAUSTA — TUNNELI AUKI...]',
  link_recv_failed: '[PARITUS EPÄONNISTUI]',
  link_recv_tunnel_lost:
    'Tunneli keskeytyi — holvi saattaa olla vielä matkalla. Skannaa QR uudelleen.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Uusi salattu viesti',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Tilapäinen viesti',
  force_update_title: '🚨 PAKOLLINEN KRIITTINEN PÄIVITYS — Jatkaaksesi Zionyxin turvallista käyttöä sinun on ladattava uusin versio.',
  force_update_desc: 'Asennettu asiakasohjelma ei ole yhteensopiva palvelimella aktiivisen vähimmäisversion kanssa.',
  force_update_versions: 'Asennettu: v{current} · Vaaditaan: v{required}',
  force_update_btn: 'PÄIVITÄ NYT',
}
